import { ItemID } from "types/common";
import { TrimmedCode } from "types/entities/Code";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { useMessage } from "hooks/useMessage";
import { useTranslations } from "translations/useTranslations";

import { QueryKeys } from "api/queryKeys";
import { getItemCodeUrl } from "api/rootUrl";

const putUpdateItemCode = (itemID: ItemID, codeID: string) => (data: TrimmedCode) =>
  axios.put(getItemCodeUrl(itemID, codeID), data).then((res) => res.data);

export const useUpdateItemCode = (itemID: ItemID, codeID: string) => {
  const { showSuccess } = useMessage();
  const queryClient = useQueryClient();
  const translations = useTranslations();

  const { mutateAsync, isLoading, error } = useMutation({
    mutationFn: putUpdateItemCode(itemID, codeID),
    onSuccess: async () => {
      await queryClient.invalidateQueries([QueryKeys.GET_ITEM_CODES, itemID]);
      showSuccess(translations["item.codes.update.modal.success"]);
    }
  });

  return { updateCode: mutateAsync, isLoading: isLoading || !!queryClient.isFetching([QueryKeys.GET_ITEM_CODES]), error };
}
